/**
 * Линейная воронка регистрации (пути без префикса локали, как в next-intl usePathname).
 * Номера шагов совпадают с cookie aztf-reg-max и registrationFlowGuard.
 *
 * 1 — registration-flow / profile-registration
 * 2 — registration-cards
 * 3 — activities
 * 4 — cart
 * 5 — order-confirmation/:id или /confirmation (оплата / подтверждение брони)
 * 6 — dashboard
 */

export function resolveRegistrationFunnelStep(pathname: string): number | null {
  const path = pathname.replace(/\/$/, '') || '/';
  if (path === '/registration-flow' || path === '/profile-registration') return 1;
  if (path === '/registration-cards') return 2;
  if (path === '/activities') return 3;
  if (path === '/cart') return 4;
  if (path === '/confirmation') return 5;
  if (path.startsWith('/order-confirmation')) return 5;
  if (path === '/dashboard') return 6;
  return null;
}

/**
 * «Назад» по воронке (не history). latestOrderId — для возврата с dashboard на последнее подтверждение заказа.
 */
export function getPreviousRegistrationFlowPath(
  pathname: string,
  latestOrderId?: string | null,
): string {
  const step = resolveRegistrationFunnelStep(pathname);
  if (step === null) return '/';
  switch (step) {
    case 1:
      return '/';
    case 2:
      return '/registration-flow';
    case 3:
      return '/registration-cards';
    case 4:
      return '/activities';
    case 5:
      return '/cart';
    case 6:
      return latestOrderId ? `/order-confirmation/${latestOrderId}` : '/cart';
    default:
      return '/';
  }
}

/**
 * Следующий шаг, если cookie maxStep уже позволяет открыть эту страницу (maxStep >= номер целевого шага).
 * С cart на order-confirmation нужен id заказа (последний в store).
 */
export function getNextRegistrationFlowPath(
  pathname: string,
  maxStep: number,
  latestOrderId: string | null,
): string | null {
  const path = pathname.replace(/\/$/, '') || '/';
  /** Оплата завершена: cookie после cart — 5, а шаг «в кабинет» требует 6 в общей логике ниже. */
  if (path === '/confirmation' && maxStep >= 5) {
    return '/dashboard';
  }

  const step = resolveRegistrationFunnelStep(pathname);
  if (step === null || step >= 6) return null;

  const targetStep = step + 1;
  if (maxStep < targetStep) return null;

  switch (step) {
    case 1:
      return '/registration-cards';
    case 2:
      return '/activities';
    case 3:
      return '/cart';
    case 4:
      if (!latestOrderId) return null;
      return `/order-confirmation/${latestOrderId}`;
    case 5:
      return '/dashboard';
    default:
      return null;
  }
}
